import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { downloadReports } from "../../../services/insurance/common";
import moment from 'moment';
import { ABSLI_ENTITYIDS_INSURANCE } from '../../../constants/insurance/constant';

export default function DownloadReports(props) {

    const [contacts, setContacts] = React.useState([]);
    const [url, setUrl] = React.useState("")
    const [dateTimeFirst, setDateTimeFirst] = React.useState(null);
    const [dateTimeSecond, setDateTimeSecond] = React.useState(null);
    const [contractId, setContractId] = React.useState('');
    const [allowedTimeDiff, setAllowedTimeDiff] = React.useState(0);

    const handleFieldChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        switchCase(name, value);
    }

    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            if (localStorage.getItem('children') && localStorage.getItem('mb_contracts')) {
                let children = localStorage.getItem('children') ? JSON.parse(localStorage.getItem('children')) : []
                let mb_contracts = localStorage.getItem('mb_contracts') ? JSON.parse(localStorage.getItem('mb_contracts')) : []
                let result = mb_contracts.filter(elem1 => children.some(function (elem2) {
                    if (parseInt(elem1.id) === parseInt(elem2.erTypeId)) {
                        elem1['er_Id'] = elem2.id;
                        return elem2
                    }
                }));
                const userDetails = JSON.parse(localStorage.getItem('user_details') || '{}');
                const isAbsliEntity = userDetails.entityId && ABSLI_ENTITYIDS_INSURANCE.includes(userDetails.entityId);
                setAllowedTimeDiff(isAbsliEntity ? 24 : 6);
                setContacts(result);
            }
        }
        return () => { isMounted = false };
    }, [])
    const switchCase = (name, value) => {
        switch (name) {
            case 'selectContract':
                setContractId(value);
                break;
            case 'firstDate':
                setDateTimeFirst(value);
                break;
            case 'secondDate':
                setDateTimeSecond(value);
                break;
            default:
                break;
        }
    }

    const getTimeDiff = () => {
        let diff = moment(dateTimeSecond).diff(moment(dateTimeFirst))
        return moment.duration(diff).asHours();
    }
    const submitDetails = (event) => {
        event.preventDefault();
        if (contractId && dateTimeFirst && dateTimeSecond && getTimeDiff() <= allowedTimeDiff) {
            downloadReports(contractId, new Date(dateTimeFirst), new Date(dateTimeSecond));
            // window.open(url, "_blank");
        }
    }

    const closePopUp = () => {
        props.closeDialog();
    }

    return (
        <div className="mt-5">
            <Box
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={(event) => submitDetails(event)}
            >
                <div className="pb-5">
                    <div className="bg-blue-100 rounded-lg p-3 font-semibold text-sm">
                        You can download the reports of specific customers between a given date-time range.
                        <div className="font-normal text-slate-900 text-xs">
                            Note: Maximum time difference allowed is {allowedTimeDiff} Hours.
                        </div>
                    </div>
                </div>
                <div className="pb-5">
                    <FormControl className="w-full">
                        <InputLabel id="selectContract">Select a Contract</InputLabel>
                        <Select
                            labelId="selectContract"
                            id="selectContract"
                            name="selectContract"
                            label="Select Contract *"
                            value={contractId}
                            onChange={(event) => handleFieldChange(event)}
                        >
                            {
                                contacts ? contacts.map(elem => (
                                    <MenuItem value={parseInt(elem.er_Id)} key={parseInt(elem.id)}>{elem.entityName}</MenuItem>
                                )) : <></>
                            }
                        </Select>
                    </FormControl>
                </div>

                <div className="pb-5 flex justify-between">
                    <FormControl>
                        <TextField
                            id="firstDate"
                            name="firstDate"
                            label="Starting Time *"
                            type="datetime-local"
                            InputProps={{ inputProps: { min: new Date() } }}
                            defaultValue={dateTimeFirst != null ? dateTimeFirst : ''}
                            onChange={(event) => handleFieldChange(event)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </FormControl>

                    <FormControl>
                        <TextField
                            id="secondDate"
                            name="secondDate"
                            label="Ending Time *"
                            type="datetime-local"
                            InputProps={{ inputProps: { min: new Date() } }}
                            defaultValue={dateTimeSecond != null ? dateTimeSecond : ''}
                            onChange={(event) => handleFieldChange(event)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </FormControl>
                </div>

                <div className='pb-5 flex justify-center text-center'>
                    <div className="m-auto bg-red-500 rounded-md w-40 text-red-100 p-1 cursor-pointer font-semibold" type="submit" variant="contained" size="large" onClick={closePopUp}>
                        <span>
                            Cancel
                        </span>
                    </div>
                    <div className={(contractId && dateTimeFirst && dateTimeSecond && getTimeDiff() <= allowedTimeDiff) ? 'm-auto bg-green-500 rounded-md w-40 text-gray-100 p-1 cursor-pointer font-semibold' : 'm-auto bg-green-300 rounded-md w-40 text-gray-500 p-1 font-semibold'} type="submit" variant="contained" size="large" onClick={submitDetails}>
                        <span>
                            Download
                        </span>
                    </div>
                </div>
            </Box>
        </div>
    );
}